<script setup>
import { Avatar } from 'ant-design-vue';

const props = defineProps({
  shape: {
    type: String,
    default: 'circle',
  },
  size: {
    type: String,
    default: 'small',
  },
  isIcon: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div>
    <Avatar :shape="props.shape" :size="props.size" class="rex-avatar-box">
      <slot v-if="!props.isIcon"></slot>

      <template v-if="props.isIcon" #icon>
        <slot></slot>
      </template>
    </Avatar>
  </div>
</template>

<style lang="scss" scoped>
.rex-avatar-box {
  @include flex-center;
}
</style>
